const mediaContactInfo = {
  displayField: 'internalName',
  name: 'Media Contact Info',
  description: 'Press Release Inquiries component',
  fields: [
    {
      id: 'internalName',
      name: 'Internal name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'description',
      name: 'Description',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'contact1Image',
      name: 'Contact 1 Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'contact1Name',
      name: 'Contact 1 Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'contact1Title',
      name: 'Contact 1 Title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'contact1Subtitle',
      name: 'Contact 1 Subtitle',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'contact1Phone',
      name: 'Contact 1 Phone',
      type: 'Integer',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'contact1Email',
      name: 'Contact 1 Email',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'contact2Image',
      name: 'Contact 2 Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'contact2Name',
      name: 'Contact 2 Name',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'contact2Title',
      name: 'Contact 2 Title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'contact2Subtitle',
      name: 'Contact 2 Subtitle',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'contact2Phone',
      name: 'Contact 2 Phone',
      type: 'Integer',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'contact2Email',
      name: 'Contact 2 Email',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'mediaContactInfo',
    version: 6,
    updatedAt: '2023-08-18T19:59:40.871Z'
  }
};
export default mediaContactInfo;